import React from "react";
import { PhoneCall, Phone, Globe, MessageSquare, Sparkles, BarChart3, Wand2 } from "lucide-react";

const ROWS = [
  { key: "observation_flat",    icon: PhoneCall,     label: "Call observation" },
  { key: "simulation_phone",    icon: Phone,         label: "Phone run", unit: "/min", note: true },
  { key: "simulation_web",      icon: Globe,         label: "Web run",   unit: "/min" },
  { key: "simulation_text",     icon: MessageSquare, label: "Text run",  unit: "/turn" },
  { key: "llm_metric",          icon: Sparkles,      label: "LLM metric" },
  { key: "non_llm_metric",      icon: BarChart3,     label: "Audio metric" },
  { key: "prompt_optimization", icon: Wand2,         label: "Optimization" },
];

function fmt(n) {
  if (n == null) return "—";
  const num = Number(n);
  return num % 1 === 0 ? num.toString() : num.toFixed(2).replace(/\.?0+$/, "");
}

export default function PricingInfoCard({ summary }) {
  const pricing = summary?.pricing || {};
  // The per-minute phone rate is destination-dependent; the shown figure is the
  // US & India rate. Only surface the caveat when phone is actually priced.
  const phoneRate = pricing["simulation_phone"];
  const showPhoneNote = phoneRate != null && Number(phoneRate) !== 0;
  return (
    <div className="bg-card rounded-xl border border-border shadow-sm overflow-hidden">
      <div className="flex items-stretch divide-x divide-gray-100">
        <div className="flex flex-col justify-center px-5 py-3 bg-muted/50/60 min-w-[140px]">
          <div className="text-[10px] text-muted-foreground font-semibold uppercase tracking-wider">
            Cost per event
          </div>
          <div className="text-[11px] text-muted-foreground mt-0.5">Applied automatically</div>
        </div>
        {ROWS.map(row => {
          const Icon = row.icon;
          const rate = pricing[row.key];
          return (
            <div
              key={row.key}
              className="flex-1 flex items-center gap-2.5 px-4 py-3 hover:bg-muted/50/40 transition-colors"
            >
              <div className="w-8 h-8 rounded-lg bg-muted/50 flex items-center justify-center flex-shrink-0">
                <Icon className="h-3.5 w-3.5 text-muted-foreground" />
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-xs text-muted-foreground truncate leading-tight">{row.label}</div>
                <div className="text-sm font-semibold text-foreground tabular-nums leading-tight mt-0.5">
                  {Number(rate) === 0 ? (
                    <span className="text-green-600">Free</span>
                  ) : (
                    <>
                      {fmt(rate)}
                      <span className="text-[10px] font-normal text-muted-foreground ml-0.5">
                        credits{row.unit || ""}
                      </span>
                      {row.note && showPhoneNote && (
                        <span className="text-amber-600 font-normal ml-0.5" aria-hidden="true">*</span>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {showPhoneNote && (
        <div className="px-5 py-2 border-t border-border bg-muted/20">
          <p className="text-[11px] text-muted-foreground">
            <span className="text-amber-600">*</span> Phone rate shown is for US &amp; India.
            Rates for other countries may vary.
          </p>
        </div>
      )}
    </div>
  );
}
